// The app's addresses. An environment's section lives at /<environment>/<section>; the app's own pages take the first
// segment's reserved names (the server refuses them as environment slugs).

export type PageName = 'compare' | 'activity' | 'team' | 'environments';

export type Route = { page: 'home' } | { page: 'vault'; env: string; section: string | null } | { page: PageName } | { page: 'missing' };

const PAGES: ReadonlySet<string> = new Set<PageName>(['compare', 'activity', 'team', 'environments']);

export function parseRoute(path: string): Route {
    const parts = path
        .split('/')
        .filter(Boolean)
        .map((part) => {
            try {
                return decodeURIComponent(part);
            } catch {
                return part;
            }
        });
    const [first, second, ...rest] = parts;
    if (!first) {
        return { page: 'home' };
    }
    if (PAGES.has(first)) {
        return second ? { page: 'missing' } : { page: first as PageName };
    }
    if (rest.length > 0) {
        return { page: 'missing' };
    }

    return { page: 'vault', env: first, section: second ?? null };
}

export function vaultPath(env: string, section?: string | null, key?: string | null): string {
    return `/${encodeURIComponent(env)}${section ? `/${encodeURIComponent(section)}` : ''}${key ? `?key=${encodeURIComponent(key)}` : ''}`;
}

export const comparePath = (section: string): string => `/compare?section=${encodeURIComponent(section)}`;
